/* Treuespur - Geschenkdialog + Cart Drawer. Einmal initialisiert, Event Delegation. */
(function () {
  if (window.TSG) return;
  var dlg = document.getElementById('treuespur-gift-dialog');
  var dataEl = document.getElementById('tsg-data');
  if (!dlg || !dataEl) return;

  var D = JSON.parse(dataEl.textContent);
  var SEC = D.drawerSection;
  var MAX = 15 * 1024 * 1024;
  var EXT = ['.jpg', '.jpeg', '.png', '.heic', '.heif'];
  var S = { p: null, sel: [], busy: false, pre: false, opener: null };

  /* Genau ein Auswahlpfad fuer den Warenkorb-Auslöser im Header. */
  var CART_TRIGGER = '[data-ts-cart-open]';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var vPick = $('[data-tsg-view="pick"]', dlg);
  var vCfg = $('[data-tsg-view="config"]', dlg);
  var foot = $('[data-tsg-foot]', dlg);
  var sub = $('[data-tsg-submit]', dlg);
  var hint = $('[data-tsg-hint]', dlg);
  var ferr = $('[data-tsg-formerr]', dlg);

  function extOk(n) {
    n = (n || '').toLowerCase();
    for (var i = 0; i < EXT.length; i++) if (n.slice(-EXT[i].length) === EXT[i]) return true;
    return false;
  }
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function drawer() { return document.getElementById('ts-drawer'); }

  /* Bubble genau so aktualisieren, wie Horizon sie aufbaut:
     Zahl in [ref="cartBubbleCount"], Sichtbarkeit ueber die Klassen. */
  function setBubble(count) {
    var n = parseInt(count, 10) || 0;
    $$('[ref="cartBubbleCount"]').forEach(function (e) {
      e.textContent = n < 100 ? String(n) : '';
      e.classList.toggle('hidden', n === 0);
    });
    $$('[ref="cartBubble"]').forEach(function (e) { e.classList.toggle('visually-hidden', n === 0); });
    $$('cart-icon').forEach(function (e) { e.classList.toggle('header-actions__cart-icon--has-cart', n > 0); });
    $$('[data-ts-cart-count]').forEach(function (e) { e.textContent = n; });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() }));
    } catch (e) {}
  }

  function applySections(json) {
    var html = json && json.sections && json.sections[SEC];
    var cur = drawer();
    if (!html || !cur) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#ts-drawer');
    if (!fresh) return false;
    var open = cur.classList.contains('is-open');
    cur.replaceWith(fresh);
    if (open) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
    setBubble(fresh.getAttribute('data-item-count'));
    document.dispatchEvent(new CustomEvent('ptk:cart-section-rendered'));
    return true;
  }

  function post(u, body, isForm) {
    var opt = { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body };
    if (!isForm) {
      opt.headers['Content-Type'] = 'application/json';
      opt.body = JSON.stringify(body);
    }
    return fetch(u, opt).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'The cart could not be updated.');
        return j;
      });
    });
  }

  var scrim = document.createElement('div');
  scrim.className = 'ts-drawer__scrim';
  document.body.appendChild(scrim);

  function openDrawer(opener) {
    var d = drawer();
    if (!d) return;
    if (opener) {
      S.opener = opener;
      opener.setAttribute('aria-expanded', 'true');
    }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-open');
    lock(true);
    var x = $('[data-ts-close-drawer]', d);
    if (x) x.focus();
  }
  // Shop-PDP bleibt sichtbar, bis Shopify den Warenkorbartikel bestätigt.
  // Das Feedback während des Uploads kommt vom vorhandenen Spinner im Button.
  function beginAdd() {}
  function clearPendingAdd() {}
  function addFailed(error) {
    // Fehlermeldung steht im Produktkonfigurator direkt unter dem Button.
    if (window.console && console.warn) console.warn('[Treuespur] Add-to-cart:', error);
  }
  function closeDrawer() {
    var d = drawer();
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }
    scrim.classList.remove('is-open');
    if (!dlg.open) lock(false);
    if (S.opener && document.contains(S.opener)) {
      S.opener.setAttribute('aria-expanded', 'false');
      S.opener.focus();
    }
    S.opener = null;
  }

  function openDialog() {
    showPick();
    if (!dlg.open) dlg.showModal();
    lock(true);
    var x = $('[data-tsg-close]', dlg);
    if (x) x.focus();
  }
  function closeDialog(thenDrawer) {
    if (!dlg.open) return;
    var finish = function () {
      dlg.classList.remove('is-closing');
      if (dlg.open) dlg.close();
      if (thenDrawer) openDrawer(); else lock(false);
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return finish();
    dlg.classList.add('is-closing');
    var done = false;
    var once = function () { if (done) return; done = true; finish(); };
    dlg.addEventListener('transitionend', once, { once: true });
    setTimeout(once, 140);
  }

  function showPick() { vPick.hidden = false; vCfg.hidden = true; foot.hidden = true; S.p = null; }
  function showCfg() { vPick.hidden = true; vCfg.hidden = false; foot.hidden = false; }

  function preload() {
    if (S.pre) return;
    S.pre = true;
    $$('[data-tsg-thumb]', dlg).forEach(function (img) {
      var i = new Image();
      if (img.srcset) i.srcset = img.srcset;
      i.src = img.src;
    });
  }

  function product(h) {
    for (var i = 0; i < D.products.length; i++) if (D.products[i].handle === h) return D.products[i];
    return null;
  }
  function isColor(n) { n = (n || '').toLowerCase(); return n.indexOf('material') > -1 || n.indexOf('farbe') > -1 || n.indexOf('color') > -1; }
  function isCount(o) {
    var n = (o.name || '').toLowerCase();
    if (n.indexOf('anh') < 0 && n.indexOf('portr') < 0 && n.indexOf('anzahl') < 0 && n.indexOf('pendant') < 0 && n.indexOf('charm') < 0) return false;
    return o.values.every(function (v) { return String(parseInt(v, 10)) === String(v).trim(); });
  }
  function dot(v) {
    v = (v || '').toLowerCase();
    if (v.indexOf('pink') > -1) return '#EAA4B8';
    if (v.indexOf('rot') > -1 || v.indexOf('red') > -1) return '#A92D34';
    if (v.indexOf('ros') > -1) return '#D9A296';
    if (v.indexOf('silb') > -1 || v.indexOf('silv') > -1) return '#C5C9CE';
    if (v.indexOf('gold') > -1) return '#D4AF37';
    return '#C8C3B8';
  }
  function countIdx() {
    for (var i = 0; i < S.p.options.length; i++) if (isCount(S.p.options[i])) return i;
    return -1;
  }
  function pets() { var i = countIdx(); return i < 0 ? 1 : (parseInt(S.sel[i], 10) || 1); }
  function variant() {
    for (var i = 0; i < S.p.variants.length; i++) {
      var v = S.p.variants[i], ok = true;
      for (var j = 0; j < S.sel.length; j++) if (v.o[j] !== S.sel[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  function pick(handle) {
    var p = product(handle);
    if (!p) return;
    if (window.TreuespurBackEngraving) {
      window.TreuespurBackEngraving.reset(dlg);
      window.TreuespurBackEngraving.mount(dlg, p.handle);
    }
    S.p = p;
    S.sel = p.options.map(function (o) { return o.values[0]; });

    var im = $('[data-tsg-sel-img]', dlg);
    if (p.img) { im.src = p.img; im.hidden = false; } else { im.hidden = true; }
    $('[data-tsg-sel-name]', dlg).textContent = p.title;

    var box = $('[data-tsg-opts]', dlg);
    box.textContent = '';
    p.options.forEach(function (o, oi) {
      var fs = document.createElement('fieldset');
      fs.className = 'tsg-field';
      fs.dataset.tsgOpt = oi;
      var lg = document.createElement('legend');
      var optionValues = (o.values || []).join(' ').toLowerCase();
      var visualLabel = (optionValues.indexOf('rot') !== -1 || optionValues.indexOf('pink') !== -1) ? 'Color' : 'Material';
      lg.textContent = isColor(o.name) ? visualLabel : (isCount(o) ? 'How many portraits?' : o.name);
      lg.appendChild(document.createElement('small'));
      fs.appendChild(lg);
      var wrap = document.createElement('div');
      wrap.className = isCount(o) ? 'tsg-opts tsg-opts--count' : 'tsg-opts';
      wrap.setAttribute('role', 'radiogroup');
      o.values.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tsg-opt';
        b.setAttribute('role', 'radio');
        b.dataset.tsgVal = v;
        b.dataset.tsgOi = oi;
        if (isColor(o.name)) {
          var d = document.createElement('span');
          d.className = 'tsg-dot';
          d.style.setProperty('--dot', dot(v));
          b.appendChild(d);
          b.appendChild(document.createTextNode(v));
        } else if (isCount(o)) {
          var n = document.createElement('span');
          n.className = 'tsg-opt__n';
          n.textContent = v;
          var w = document.createElement('span');
          w.className = 'tsg-opt__w';
          w.textContent = parseInt(v, 10) === 1 ? 'portrait' : 'portraits';
          b.appendChild(n);
          b.appendChild(w);
        } else {
          b.textContent = v;
        }
        wrap.appendChild(b);
      });
      fs.appendChild(wrap);
      box.appendChild(fs);
    });

    showCfg();
    sync();
  }

  function sync() {
    if (!S.p) return;
    $$('[data-tsg-opt]', dlg).forEach(function (fs) {
      var i = +fs.dataset.tsgOpt;
      $$('[data-tsg-val]', fs).forEach(function (b) {
        var on = b.dataset.tsgVal === S.sel[i];
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var sm = fs.querySelector('legend small');
      if (sm) sm.textContent = S.sel[i] || '';
    });

    var want = pets(), multi = want > 1;
    var photoLabel = $('[data-tsg-photo-label]', dlg);
    if (photoLabel) {
      photoLabel.hidden = !S.p.needsPhoto;
      photoLabel.style.display = S.p.needsPhoto ? '' : 'none';
    }
    $$('[data-tsg-pet]', dlg).forEach(function (g, i) {
      var petHidden = i >= want;
      g.hidden = petHidden;
      g.style.display = petHidden ? 'none' : '';
      var t = $('[data-tsg-pet-title]', g);
      if (t) t.hidden = !multi;
      var drop = $('[data-tsg-drop]', g);
      var name = $('.tsg-name', g);
      if (drop) {
        drop.hidden = !S.p.needsPhoto;
        drop.style.display = S.p.needsPhoto ? '' : 'none';
      }
      if (name) {
        name.hidden = !S.p.needsName;
        name.style.display = S.p.needsName ? '' : 'none';
        var input = $('[data-tsg-name]', name);
        input.maxLength = S.p.nameLimit || 9;
        if (input.value.length > input.maxLength) input.value = input.value.slice(0, input.maxLength);
        $('[data-tsg-counter]', g).textContent = input.value.length + '/' + input.maxLength;
        input.required = S.p.needsName && !S.p.needsPhoto && !petHidden;
        var label = name.querySelector('label');
        if (label && label.firstChild.nodeType === 3) label.firstChild.textContent = S.p.needsPhoto ? 'Pet name (optional) ' : 'Pet name ';
      }
    });

    if (window.TreuespurBackEngraving) window.TreuespurBackEngraving.sync(dlg);
    var v = variant();
    if (v) $('[data-tsg-sel-price]', dlg).innerHTML = v.p;
    state();
  }

  function missing() {
    var out = [], want = pets(), multi = want > 1;
    $$('[data-tsg-pet]', dlg).slice(0, want).forEach(function (g, i) {
      var f = $('[data-tsg-file]', g), n = $('[data-tsg-name]', g);
      var l = multi ? 'pet ' + (i + 1) : 'your pet';
      if (S.p.needsPhoto && (!f.files || !f.files.length)) out.push('Photo for ' + l);
      if (S.p.needsName && !S.p.needsPhoto && !n.value.trim()) out.push('Name for ' + l);
    });
    if (window.TreuespurBackEngraving) {
      window.TreuespurBackEngraving.collect(dlg).forEach(function (back) {
        if (!back.text) out.push('Back engraving text for charm ' + back.index);
      });
    }
    return out;
  }

  function state() {
    if (!S.p) return;
    var v = variant(), miss = missing();
    sub.disabled = !(v && v.a && !miss.length) || S.busy;
    if (!v || !v.a) hint.textContent = 'This combination is currently unavailable.';
    else if (miss.length) hint.textContent = 'Still needed to continue: ' + miss.join(', ') + '.';
    else hint.textContent = '';
  }

  function accept(g, file) {
    var err = $('[data-tsg-err]', g), pv = $('[data-tsg-prev]', g), idle = $('[data-tsg-idle]', g);
    var th = $('[data-tsg-thumbimg]', g), fn = $('[data-tsg-fname]', g), inp = $('[data-tsg-file]', g);
    err.textContent = '';
    if (g._u) { URL.revokeObjectURL(g._u); g._u = null; }
    if (!file) { pv.hidden = true; idle.hidden = false; th.removeAttribute('src'); return state(); }
    if (!extOk(file.name)) {
      inp.value = ''; pv.hidden = true; idle.hidden = false;
      err.textContent = 'This file format is not supported. Please use JPG, PNG or HEIC.';
      return state();
    }
    if (file.size > MAX) {
      inp.value = ''; pv.hidden = true; idle.hidden = false;
      err.textContent = 'This photo is too large. Please choose a file up to 15 MB.';
      return state();
    }
    g._u = URL.createObjectURL(file);
    th.src = g._u;
    fn.textContent = file.name;
    pv.hidden = false;
    idle.hidden = true;
    state();
  }

  function addGift() {
    var v = variant();
    if (!v || sub.disabled || S.busy || missing().length) return;
    S.busy = true;
    sub.disabled = true;
    sub.classList.add('is-busy');
    ferr.hidden = true;

    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', '1');
    $$('[data-tsg-pet]', dlg).slice(0, pets()).forEach(function (g, i) {
      var f = $('[data-tsg-file]', g), n = $('[data-tsg-name]', g);
      if (S.p.needsPhoto && f.files && f.files[0]) fd.append('properties[Pet ' + (i + 1) + ' – Photo]', f.files[0]);
      if (S.p.needsName && n.value.trim()) fd.append('properties[Pet ' + (i + 1) + ' – Name]', n.value.trim());
    });
    if (window.TreuespurBackEngraving) {
      var backs = window.TreuespurBackEngraving.collect(dlg);
      if (backs.length) fd.append('properties[_treuespur_back_engravings]', JSON.stringify(backs));
    }
    fd.append('properties[_treuespur_personalized]', 'true');
    fd.append('sections', SEC);
    fd.append('sections_url', D.cartUrl);

    post(D.cartAdd + '.js', fd, true)
      .then(function (j) {
        function finish(ok) {
          if (!ok) { window.location.assign(D.cartUrl); return; }
          if (window.TreuespurBackEngraving) window.TreuespurBackEngraving.reset(dlg);
          S.busy = false;
          sub.classList.remove('is-busy');
          if (dlg.open) closeDialog(true); else openDrawer();
        }
        if (applySections(j)) { finish(true); return; }
        return fetch(D.cartUrl + '?sections=' + encodeURIComponent(SEC), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (sections) { finish(applySections({ sections: sections })); })
          .catch(function () { window.location.assign(D.cartUrl); });
      })
      .catch(function (e) {
        S.busy = false;
        sub.classList.remove('is-busy');
        ferr.textContent = e.message;
        ferr.hidden = false;
        state();
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target, c;
    if (!t.closest) return;

    if ((c = t.closest('[data-tsg-pick]'))) { pick(c.dataset.tsgPick); return; }
    if (t.closest('[data-tsg-back]')) { showPick(); return; }
    if (t.closest('[data-tsg-close]')) { closeDialog(true); return; }
    if (t.closest('[data-tsg-submit]')) { addGift(); return; }
    if ((c = t.closest('[data-tsg-val]'))) { S.sel[+c.dataset.tsgOi] = c.dataset.tsgVal; sync(); return; }
    if ((c = t.closest('[data-tsg-change]'))) { $('[data-tsg-file]', c.closest('[data-tsg-pet]')).click(); return; }
    if ((c = t.closest('[data-tsg-removefile]'))) {
      var g = c.closest('[data-tsg-pet]');
      $('[data-tsg-file]', g).value = '';
      accept(g, null);
      return;
    }

    if (t.closest('[data-ts-open-gift]')) { closeDrawer(); openDialog(); return; }
    if (t.closest('[data-ts-close-drawer]')) { closeDrawer(); return; }

    if ((c = t.closest('[data-ts-remove]'))) {
      e.preventDefault();
      e.stopPropagation();
      if (S.busy) return;
      S.busy = true;
      c.disabled = true;
      c.setAttribute('aria-busy', 'true');
      var removeButton = c;
      function showRemovalError(error) {
        var current = drawer();
        var where = current && (current.querySelector('.ts-dw__body') || current.querySelector('.ts-dw__foot'));
        if (!where) return;
        var alert = where.querySelector('[data-ts-remove-error]');
        if (!alert) {
          alert = document.createElement('p');
          alert.setAttribute('data-ts-remove-error', '');
          alert.setAttribute('role', 'alert');
          where.prepend(alert);
        }
        alert.textContent = error.message || 'Could not remove this item. Please try again.';
      }
      post(D.cartChange + '.js', {
        id: removeButton.dataset.tsRemove,
        quantity: 0,
        sections: SEC,
        sections_url: D.cartUrl || '/cart'
      }).then(function (result) {
        if (applySections(result)) return;
        // Section-render failure: load fresh HTML without repeating the removal.
        return fetch((D.cartUrl || '/cart') + '?sections=' + encodeURIComponent(SEC), {
          credentials: 'same-origin', cache: 'no-store'
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not update the cart view.');
          return response.json();
        }).then(function (sections) {
          if (!applySections({ sections: sections })) throw new Error('Could not update the cart view.');
        });
      }).catch(showRemovalError).then(function () {
        S.busy = false;
        if (document.contains(removeButton)) {
          removeButton.disabled = false;
          removeButton.removeAttribute('aria-busy');
        }
      });
      return;
    }
    if ((c = t.closest('[data-ts-add-upsell]'))) {
      if (S.busy) return;
      S.busy = true;
      c.disabled = true;
      post(D.cartAdd + '.js', { items: [{ id: +c.dataset.tsAddUpsell, quantity: 1 }], sections: SEC })
        .then(applySections).catch(function () {})
        .then(function () { S.busy = false; });
      return;
    }

    /* Warenkorb-Auslöser im Header: nur uebernehmen, wenn #ts-drawer existiert.
       Sonst bleibt der normale Weg zu routes.cart_url erhalten. */
    if ((c = t.closest(CART_TRIGGER))) {
      if (!drawer()) return;
      e.preventDefault();
      e.stopPropagation();
      openDrawer(c);
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var g = e.target.closest('[data-tsg-pet]');
    if (g && e.target.matches('[data-ppc-back-check]')) state();
    if (g && e.target.matches('[data-tsg-file]')) accept(g, e.target.files && e.target.files[0]);
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ppc-back-text]') && dlg.contains(e.target)) { state(); return; }
    if (!e.target.matches || !e.target.matches('[data-tsg-name]')) return;
    var g = e.target.closest('[data-tsg-pet]');
    if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength);
    var c = $('[data-tsg-counter]', g);
    if (c) c.textContent = e.target.value.length + '/' + e.target.maxLength;
    state();
  });

  ['pointerdown', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest('[data-ppc-submit]')) preload();
    }, { passive: true, capture: true });
  });

  dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(true); });
  scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !dlg.open) closeDrawer();
  });

  // Nach erfolgreichem Hinzufügen nie einen leeren Warenkorb als Erfolg zeigen.
  function hasConfirmedAddedItem(json) {
    var html = json && json.sections && json.sections[SEC];
    if (typeof html !== 'string') return false;
    var match = html.match(/data-item-count=["'](\d+)["']/);
    return !!match && Number(match[1]) > 0;
  }

  // Native Horizon product forms also need to open the customized drawer.
  // Skip quantity changes and failures; only respond to successful add actions.
  document.addEventListener('cart:update', function (event) {
    var data = event && event.detail && event.detail.data;
    if (!data || data.didError || data.source !== 'product-form-component' || !drawer()) return;
    if (window.TSG && window.TSG.afterFirstAdd) {
      window.TSG.afterFirstAdd({ sections: data.sections || {} });
    }
  });

  window.TSG = {
    sectionId: SEC,
    afterFirstAdd: function (json) {
      // Erfolgsweg: die im gleichen Request gelieferte echte Section öffnen.
      clearPendingAdd();
      if (hasConfirmedAddedItem(json) && applySections(json)) {
        openDrawer();
        return Promise.resolve(true);
      }
      // Shopify hat den Artikel bestätigt, aber keine renderbare Section
      // geliefert: nur neu rendern, nie erneut in den Warenkorb legen.
      var cartPath = D.cartUrl || '/cart';
      var querySeparator = cartPath.indexOf('?') === -1 ? '?' : '&';
      return fetch(cartPath + querySeparator + 'sections=' + encodeURIComponent(SEC), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart section unavailable');
        return response.json();
      }).then(function (sections) {
        if (!hasConfirmedAddedItem({ sections: sections }) || !applySections({ sections: sections })) throw new Error('Cart section incomplete');
        openDrawer();
        return true;
      }).catch(function (error) {
        // Shopify may fail to render an individual section even though the
        // item was added. Retrieve the drawer from the real cart page HTML
        // without sending the shopper away from the product page.
        if (window.console && console.warn) console.warn('[PawToKeep] Drawer section retry:', error);
        return fetch(cartPath, {
          credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'text/html' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Full cart HTML unavailable');
          return response.text();
        }).then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.getElementById('ts-drawer');
          if (!fresh || Number(fresh.getAttribute('data-item-count')) < 1) {
            throw new Error('Drawer missing or empty in cart HTML');
          }
          var result = { sections: {} };
          result.sections[SEC] = fresh.outerHTML;
          if (!applySections(result)) throw new Error('Unable to update drawer from cart HTML');
          openDrawer();
          return true;
        }).catch(function (fallbackError) {
          // Only leave the product page if both section rendering and the
          // full-page drawer extraction fail. Never show stale cart totals.
          if (window.console && console.warn) console.warn('[PawToKeep] Drawer HTML fallback:', fallbackError);
          window.location.assign(cartPath);
          return false;
        });
      });
    },
    beginAdd: beginAdd,
    addFailed: addFailed,
    openDialog: openDialog,
    openDrawer: openDrawer,
    applySections: applySections,
    setBubble: setBubble
  };
})();


